import React from "react";
import Shifts from "screens/Shifts/index";
const ConfrimedShifts = () => {
  return <Shifts status="confirmed" />;
};

export default ConfrimedShifts;
